require(['knockout', 'jquery', 'bindings/bindings-register', 'components/component-register', 'domReady!'], function (ko, $) {

    /************************************************/
    /* Page Object                                  */
    /************************************************/
    var sm = window.sm = window.sm || {};

    if (typeof sm.portal === "undefined") {
        $.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.page === "undefined") {
        $.extend(sm.portal, { page: {} });
    }
    if (typeof sm.portal.page.application === "undefined") {
        $.extend(sm.portal.page, { application: {} });
    }

    function initPage() {

        if (performance.navigation.type == 2) {
            window.history.go(-1); 
        }
       

        // Create the View Model
        window.viewModel = new sm.portal.vm.ApplicationViewModel();
        // Bind to Page Elements
        ko.applyBindings(window.viewModel);

        loadTemplates();
    }


    function loadTemplates() {
        if(!sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization('loadConsolidatedTemplates'))){
            $.when(
                sm.portal.vm.custom.loadCustomTemplate(),
                sm.portal.utility.loadTemplate('ApplicationTemplate', 'formTemplates'),
                sm.portal.utility.loadTemplate('localizations\\UK\\ApplicationTemplateUK', 'formTemplates'),
                sm.portal.utility.loadTemplate('AccountTemplate', 'accountTemplates'),
                sm.portal.utility.loadTemplate('PortalValidationMessagesTemplate', 'portalValidationMessagesTemplates'),
                sm.portal.utility.loadTemplate('PortalWarningMessagesTemplate', 'portalWarningMessagesTemplates'),
            ).done(function () {
    
                //Signal Templates are loaded
                window.viewModel.TemplatesLoaded(true);
     
                // Get the parameters from the Query String
                var personGID = sm.portal.utility.getParameterByName('gid');
                var applicationGID = sm.portal.utility.getParameterByName('attemptGID');
    
                // Initialize the Application Processor
                window.viewModel.Initialize(applicationGID, personGID);
            });
        }else{
            $.when(
                sm.portal.vm.custom.loadCustomTemplate(),
                sm.portal.utility.loadTemplate('ApplicationTemplate', 'formTemplates'),
                sm.portal.utility.loadTemplate('localizations\\APAS\\ApplicationTemplateAPAS', 'formTemplates'),
                sm.portal.utility.loadTemplate('localizations\\EU\\ApplicationTemplateEU', 'formTemplates'),
                sm.portal.utility.loadTemplate('localizations\\UK\\ApplicationTemplateUK', 'formTemplates'),
                sm.portal.utility.loadTemplate('ValidationFieldTemplate', 'validationTemplates'),
                sm.portal.utility.loadTemplate('MailingAddressTemplate', 'addressFormTemplates'),
                sm.portal.utility.loadTemplate('MailingAddressTemplateNew', 'addressFormTemplatesNew'),
                sm.portal.utility.loadTemplate('AccountTemplate', 'accountTemplates'),
                sm.portal.utility.loadTemplate('TermsAndConditionsTemplate', 'termsTemplates'),
                sm.portal.utility.loadTemplate('PortalValidationMessagesTemplate', 'portalValidationMessagesTemplates'),
                sm.portal.utility.loadTemplate('PortalWarningMessagesTemplate', 'portalWarningMessagesTemplates'),
                sm.portal.utility.loadTemplate('LoggedInPageHeaderTemplate', 'loggedInPageHeaderTemplates'),
                sm.portal.utility.loadTemplate('localizations\\Conservatoire\\ApplicationTemplateConservatoire', 'formTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\PersonTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\ContactTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\AcademicTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\DemographicTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\EmploymentTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\CollegeTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\HighSchoolTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\QualificationTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\TestScoreTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\ApplicationInformationTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\ConservatoireTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\AccessibilityNeedsTemplate', 'summaryTemplates'),
                sm.portal.utility.loadTemplate('SummaryTemplates\\LanguagesTemplate', 'summaryTemplates'),
                
            ).done(function () {
    
                //Signal Templates are loaded
                window.viewModel.TemplatesLoaded(true);
    
                // Get the parameters from the Query String
                var personGID = sm.portal.utility.getParameterByName('gid');
                var applicationGID = sm.portal.utility.getParameterByName('attemptGID');
    
                // Initialize the Application Processor
                window.viewModel.Initialize(applicationGID, personGID);
            });
        }
        
    }

    // Loads a Application Education Matrix List Model
    function loadMatrixListItemModels(source, target) {
        for (var i = 0; i < source.length; i++) {
            target.push(new sm.portal.vm.MatrixListItemViewModel({
                PrimaryID: source[i].PrimaryID,
                PrimaryText: source[i].PrimaryText,
                LevelIDs: source[i].LevelIDs,
                CampusIDs: source[i].CampusIDs,
                DeliveryMethodIDs: source[i].DeliveryMethodIDs,
                GoalIDs: source[i].GoalIDs,
                ProgramIDs: source[i].ProgramIDs,
                EntryPointIDs: source[i].EntryPointIDs,
                LevelOfStudyIDs: source[i].LevelOfStudyIDs,
                IsDefault: source[i].IsDefaultLevelOfStudy,
                Sequence: source[i].LevelOfStudySequence,
                AdmissionsProgramOfferingItemIDs: source[i].AdmissionsProgramOfferingItemIDs,
            }));
        }
        return target;
    };

    // Standard Application View Model Response Handler
    function modelDataResponseHandler(self, data, applicationMID, personMID) {

        var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

        if (data.Status == 'success') {

            self.LoadModel(container);
        }
        else if (data.Status == 'validationerror') {

            window.viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);

        } else if (data.Status == 'error') {

            var cnt = self.DataLoadErrorCount() + 1;
            self.DataLoadErrorCount(cnt);

            if (cnt <= 1) {      // 1 extra try
                self.DataLoaded(false);
                self.DataLoading(false);
                self.GetModelData(false, applicationMID, personMID);
            } else {
                window.viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
            }
        }
        self.UnBlockContainer();
    }

    // Standard Application View Model Error Handler
    function modelErrorHandler(self, data) {
        var statusText = data.statusText;
        var responseMsg = "Unknown Error";

        try {
            if (data != null && data.responseText != null) {
                responseMsg = $.parseJSON(data.responseText).Message;
            }
        } catch (e) {
            responseMsg = "Could not retrieve error message";
        }

        var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
        window.viewModel.HandleError('There was an error retrieving data for this section', [messageToUser]);
        self.UnBlockContainer();
    }

    function handleErrorWithMessages(self, data, action) {
        self && self.UnBlockContainer && self.UnBlockContainer();
        window.viewModel.ThrowErrorWithRelevantMessage(data, action);
    }

    function fieldHelp () {
        $('.field span.icon.info, .field button.icon.info').each(function () {
            var that = $(this);
            var myInfo = that.next('.fieldHelp');
            that.on('click', function () {
                if (that.hasClass('active')) {
                    that.removeClass('active');
                    myInfo.removeClass('active');
                    that.attr('aria-expanded', false);
                } else {
                    that.addClass('active');
                    myInfo.addClass('active');
                    that.attr('aria-expanded', true);
                }
            });
        });
    }

    function revealAppContent() {
        $('.applicationContainer').not('[data-processed="true"]').each(function () {
            $(this).css('display', 'block');
            $(this).attr('data-processed', true);
        });
    }

    function addDetailedListItem() {

        $('.addDetailedListItem').on('click', function () {
            //e.preventDefault();

            // hide the none found message
            $('.noneAdded').hide();

            // hide the display form
            $('.dataDisplayView').hide();

            // show the input form
            $('.dataEntryView').show();

            sm.portal.ui.comboBox();
        });
    }

    function additionalFieldsToggle() {
        $('.additionalFieldsHeader').on('click keypress', function (event) {
            var that = $(this);
            var myIcon = that.find('span.icon');

            if (myIcon.hasClass('show')) {
                if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                    myIcon.removeClass('show').addClass('hide');
                    that.next().addClass('active');
                    that.attr('aria-expanded', true);
                }
            }
            else {
                if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                    myIcon.removeClass('hide').addClass('show');
                    that.next().removeClass('active');
                    that.attr('aria-expanded', false);
                }
            }
        });
    }

    $.extend(true, sm.portal.page.application, {
        initPage: initPage,
        loadMatrixListItemModels: loadMatrixListItemModels,
        modelDataResponseHandler: modelDataResponseHandler,
        modelErrorHandler: modelErrorHandler,
        handleErrorWithMessages: handleErrorWithMessages,
        fieldHelp: fieldHelp,
        revealAppContent: revealAppContent,
        addDetailedListItem: addDetailedListItem,
        additionalFieldsToggle: additionalFieldsToggle,
    });



    sm.portal.page.application.initPage();
});
